export default __webpack_public_path__ + "static/media/Lip_3_F.48786ade.svg";